<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Acknowledgements</p>
<p class="noindent">I’d like to thank Ruth from the Grand Rapids Public Library for helping me find photos and old newspaper articles. She was an immense help! Thank you as well to Tobin Buhk, fellow History Press author, for lending me some of his photos for inclusion in the book and helping me touch up old pictures; my commissioning editor, Greg Dumais, for having patience with me; David Schock, PhD, for his research and films on the Mina Dekker case and his website “Delayed Justice,” which was very valuable; Carl Bajema’s extensive collection of newspaper clippings—his work has been helpful on many of my research projects; Julie Williams for listening again…and again; Jeanette Weiden, who is always ready to help with her awesome genealogy skills; and last, to my mother, grandparents and friends, who are all very supportive of my 101 hobbies.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?3187a9c4